export function reachGoal(goalName, params) {
  if (window.yaCounter) {
    window.yaCounter.reachGoal(goalName, params)
  }
}
